import styled from 'styled-components';

export const Container = styled.section`
  border-radius: 4px;
  display: flex;
  font-family: 'Oswald', sans-serif;
  font-size: 42px;
`;
Container.displayName = 'Container';

export const Color = styled.div`
  background-color: #f00;
  border-radius: 4px;
  height: 3px;
  margin-bottom: 4px;
  width: 100%;
`;
Color.displayName = 'Color';

export const Points = styled.div`
  min-width: 45px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  background-color: #ccc;
  color: #000;
  display: flex;
  font-weight: bold;
  justify-content: center;
  min-width: 100px;
  padding: 0 16px;
  text-align: center;
`;
PointsContainer.displayName = 'PointsContainer';

export const QuarterTime = styled.div`
  align-items: center;
  background-color: #ccc;
  color: #000;
  display: flex;
  font-weight: bold;
  justify-content: center;
  min-width: 50px;
  padding: 0 12px;
  text-align: center;
`;
QuarterTime.displayName = 'QuarterTime';

export const Space = styled.div`
  padding: 0 4px;
`;
Space.displayName = 'Space';

export const TeamName = styled.div`
  background-color: #eee;
  color: #000;
  min-width: 130px;
  padding: 0 32px;
  text-align: center;

  &:first-child {
    border-radius: 4px 0 0 4px;
  }
`;
TeamName.displayName = 'TeamName';

export const Timer = styled.div`
  align-items: center;
  background-color: #333;
  color: #fff;
  display: flex;
  justify-content: center;
  min-width: 130px;
  padding: 0 16px;
  text-align: center;

  &:last-child {
    border-radius: 0 4px 4px 0;
  }
`;
Timer.displayName = 'Timer';
